import React, { Component } from "react";
import {withNamespaces} from "react-i18next";
import {Card} from "react-bootstrap";
import MobilePcListItemView from "./MobilePcListItemView";

class MobilePcListView extends Component {
    render() {
        const { data } = this.props;

        return (
            <React.Fragment>
                { data?.map((item, idx) => {
                    return (<Card key={idx}>
                        <Card.Body>
                            <MobilePcListItemView key={idx} item={item} />
                        </Card.Body>
                    </Card>)
                }) }
            </React.Fragment>
        )
    }
}
export default withNamespaces()(MobilePcListView);
